<div class="error-background" [style.backgroundImage]="'url('+background+')'">
    <div class="background-dimmer">
    </div>
        <div class="error-container">
            <img class="error-logo" src="../../../assets/images/abcis-white.png"/>

            <div class="code-container">
                <span
                [style.backgroundImage]="'url('+foreground+')'"
                >{{statusText}}</span>
            </div>

            <span class="error-text">
                <h2>Oops! {{errorCode.statusText}}</h2> 
                <p>Don't worry our capable dev team are fixing this issue as quickly as possible :)</p>
            </span>
        </div>
    <button class="hidden-button" (click)="GenerateErrorBackgroundLooks()"></button>
</div>
